<section class="professional-hero-section">
  <div class="container">
    <div class="row align-items-center min-vh-100">
      <div class="col-lg-6 col-md-12">
        <div class="hero-content">
          <div class="company-badge mb-4">
            <span class="badge-professional">
              <i class="bx bx-chip"></i>
              C3 Series Compute-Optimized Instances
            </span>
          </div>
          <h1 class="hero-title-professional mb-4">
            Compute-Optimized C3 Series
            <span class="text-highlight">Cloud Instances</span>
          </h1>
          <p class="hero-description-professional mb-4">
            High-performance compute-optimized instances designed for CPU-intensive applications, high-traffic web servers,
            batch processing, and scientific computing with excellent price-performance.
          </p>
          <div class="key-benefits mb-4">
            <div class="benefit-item">
              <i class="bx bx-check-circle"></i>
              <span>Latest-generation processors with high clock speeds</span>
            </div>
            <div class="benefit-item">
              <i class="bx bx-check-circle"></i>
              <span>Consistent CPU performance with no resource contention</span>
            </div>
            <div class="benefit-item">
              <i class="bx bx-check-circle"></i>
              <span>Scalable resources to match demanding workloads</span>
            </div>
          </div>
          <div class="hero-actions-professional mb-4">
            <a routerLink="/contact" class="btn-professional-primary">
              <i class="bx bx-phone"></i>
              Contact Sales Team
            </a>
            <a routerLink="/pricing" class="btn-professional-secondary">
              <i class="bx bx-purchase-tag"></i>
              View Pricing
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="hero-visual-professional">
          <div class="visual-container">
            <img src="assets/img/c3-series-hero.png" alt="C3 Series" class="hero-image-professional">
            <div class="info-card card-performance">
              <div class="card-icon">
                <i class="bx bx-tachometer"></i>
              </div>
              <div class="card-info">
                <div class="card-value">3.8GHz</div>
                <div class="card-label">Base Clock</div>
              </div>
            </div>
            <div class="info-card card-cores">
              <div class="card-icon">
                <i class="bx bx-chip"></i>
              </div>
              <div class="card-info">
                <div class="card-value">32</div>
                <div class="card-label">CPU Cores</div>
              </div>
            </div>
            <div class="info-card card-memory">
              <div class="card-icon">
                <i class="bx bx-memory-card"></i>
              </div>
              <div class="card-info">
                <div class="card-value">128GB</div>
                <div class="card-label">Max Memory</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="modern-features-section">
  <div class="container">
    <div class="section-header text-center mb-5">
      <div class="section-badges mb-3">
        <span class="section-badge">
          <i class="bx bx-chip"></i>
          C3 Series Features
        </span>
      </div>
      <h2 class="section-title mb-3">
        Compute-Optimized <span class="text-gradient">Performance</span>
      </h2>
      <p class="section-description mx-auto">
        Designed for CPU-intensive workloads with high-performance processors, fast networking, and enterprise-grade
        reliability.
      </p>
    </div>
    <div class="features-grid">
      <div class="row g-4">
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-tachometer"></i>
              </div>
            </div>
            <h3>High CPU Performance</h3>
            <p>
              Powered by latest-generation processors with high clock speeds for maximum performance across demanding
              workloads.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Learn more about CPU-optimized workloads
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-chip"></i>
              </div>
            </div>
            <h3>Latest Processors</h3>
            <p>
              Equipped with cutting-edge CPU architectures for optimal compute performance and energy efficiency.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Discuss processor options with an expert
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-sync"></i>
              </div>
            </div>
            <h3>Consistent Performance</h3>
            <p>
              Guaranteed consistent CPU performance with no noisy neighbors or resource contention across shared
              infrastructure.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Explore performance benchmarks
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-expand"></i>
              </div>
            </div>
            <h3>Scalable Resources</h3>
            <p>
              Easily scale CPU cores and memory to match workload requirements without downtime or complex migrations.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Plan your scaling strategy
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-lock"></i>
              </div>
            </div>
            <h3>Enterprise Security</h3>
            <p>
              Built-in security controls, encryption, and compliance-ready architecture for regulated and sensitive
              workloads.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Review security and compliance options
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="feature-card h-100">
            <div class="feature-icon mb-4">
              <div class="icon-background">
                <i class="bx bx-money"></i>
              </div>
            </div>
            <h3>Cost Effective</h3>
            <p>
              Optimized pricing for compute-intensive workloads with flexible billing options and predictable monthly
              costs.
            </p>
            <a routerLink="/contact" class="btn-feature-link">
              Get a tailored cost estimate
              <i class="bx bx-right-arrow-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="specifications-section">
  <div class="container">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">
        Technical <span class="text-gradient">Specifications</span>
      </h2>
      <p class="section-description mx-auto">
        Detailed specifications of C3 Series compute-optimized instances to help you architect the right solution.
      </p>
    </div>
    <div class="specs-table-container">
      <table class="specs-table">
        <thead>
          <tr>
            <th>Component</th>
            <th>Specification</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <i class="bx bx-chip"></i>
              Processor
            </td>
            <td>Intel Xeon Platinum</td>
            <td>Latest-generation processors with high clock speeds for demanding applications.</td>
          </tr>
          <tr>
            <td>
              <i class="bx bx-tachometer"></i>
              Clock Speed
            </td>
            <td>3.8 GHz Base / 4.5 GHz Boost</td>
            <td>High-performance computing capabilities for latency-sensitive workloads.</td>
          </tr>
          <tr>
            <td>
              <i class="bx bx-memory-card"></i>
              Memory
            </td>
            <td>4GB – 128GB DDR4</td>
            <td>ECC memory with error correction for reliable long-running services.</td>
          </tr>
          <tr>
            <td>
              <i class="bx bx-hdd"></i>
              Storage
            </td>
            <td>NVMe SSD</td>
            <td>Up to 2TB high-performance storage for fast I/O workloads.</td>
          </tr>
          <tr>
            <td>
              <i class="bx bx-transfer"></i>
              Network
            </td>
            <td>Up to 25 Gbps</td>
            <td>High-throughput networking with low latency connectivity.</td>
          </tr>
          <tr>
            <td>
              <i class="bx bx-shield-quarter"></i>
              Security
            </td>
            <td>Hardware-based encryption</td>
            <td>TPM 2.0, secure boot, and encryption options for sensitive data.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<section class="pricing-plans-section">
  <div class="container">
    <div class="section-header text-center mb-5">
      <span class="section-badge">
        <i class="bx bx-purchase-tag"></i>
        C3 Series Plans
      </span>
      <h2 class="section-title">
        Flexible <span class="text-gradient">Configuration Options</span>
      </h2>
      <p class="section-description mx-auto">
        Choose the right instance size for your compute-intensive workloads, from entry-level to enterprise-grade.
      </p>
    </div>
    <div class="pricing-table-container">
      <table class="pricing-table">
        <thead>
          <tr>
            <th>Instance</th>
            <th>vCPU</th>
            <th>RAM</th>
            <th>NVMe Storage</th>
            <th>Network</th>
            <th>Bandwidth</th>
            <th>Configuration</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="instance-info">
                <div class="instance-name">C3-2</div>
                <div class="instance-desc">Basic Compute</div>
              </div>
            </td>
            <td>2</td>
            <td>4 GB</td>
            <td>40 GB</td>
            <td>1 Gbps</td>
            <td>2 TB</td>
            <td>
              <span class="badge bg-light text-dark">Basic</span>
            </td>
            <td>
              <a routerLink="/contact" class="btn-pricing-table">
                Contact Us
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <div class="instance-info">
                <div class="instance-name">C3-4</div>
                <div class="instance-desc">Standard Compute</div>
              </div>
            </td>
            <td>4</td>
            <td>8 GB</td>
            <td>80 GB</td>
            <td>2 Gbps</td>
            <td>4 TB</td>
            <td>
              <span class="badge bg-primary-subtle text-primary">Standard</span>
            </td>
            <td>
              <a routerLink="/contact" class="btn-pricing-table">
                Contact Us
              </a>
            </td>
          </tr>
          <tr class="popular">
            <td>
              <div class="instance-info">
                <div class="instance-name">C3-8</div>
                <div class="instance-desc">High Performance</div>
              </div>
              <span class="popular-badge-table">Most Popular</span>
            </td>
            <td>8</td>
            <td>16 GB</td>
            <td>160 GB</td>
            <td>4 Gbps</td>
            <td>8 TB</td>
            <td>
              <span class="badge bg-purple-100 text-purple-800">High Performance</span>
            </td>
            <td>
              <a routerLink="/contact" class="btn-pricing-table">
                Contact Us
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <div class="instance-info">
                <div class="instance-name">C3-16</div>
                <div class="instance-desc">Enterprise Compute</div>
              </div>
            </td>
            <td>16</td>
            <td>32 GB</td>
            <td>320 GB</td>
            <td>8 Gbps</td>
            <td>16 TB</td>
            <td>
              <span class="badge bg-indigo-100 text-indigo-800">Enterprise</span>
            </td>
            <td>
              <a routerLink="/contact" class="btn-pricing-table">
                Contact Us
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pricing-note mt-3">
      <p>
        <i class="bx bx-info-circle"></i>
        All plans include 24/7 support, automatic backups, and enterprise-grade security.
        <small>Contact us for custom configurations and reserved capacity pricing.</small>
      </p>
    </div>
  </div>
</section>

<section class="cta-section">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-10">
        <div class="cta-content">
          <h2 class="cta-title">
            Ready to deploy high-performance compute instances?
          </h2>
          <p class="cta-description">
            Get started with C3 Series cloud instances and experience consistent CPU performance, secure infrastructure,
            and expert support.
          </p>
          <div class="cta-actions d-flex flex-wrap justify-content-center">
            <a routerLink="/contact" class="btn btn-primary">
              <i class="bx bx-phone"></i>
              Contact Us
            </a>
            <a routerLink="/contact" class="btn btn-outline-primary">
              <i class="bx bx-chat"></i>
              Talk to an Expert
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

